import React from 'react';
import { tr } from '../../i18n/i18n';

// Relative path from this file to the gif in src/assets
import loaderGif from '../../assets/images/loading/suspense-loading.gif';

const SuspenseLoader: React.FC = () => {
  return (
    <div
      role="status"
      className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm"
    >
      <div className="flex flex-col items-center gap-3 p-4">
        <img src={loaderGif} alt={tr('fe_loading.loading', "Loading")} className="w-56 max-w-full h-auto drop-shadow-lg" />
      </div>
    </div>
  );
};

export default SuspenseLoader;
